// US-format phone helpers shared by App.js (waitlist) and AdminApp.js (login).
// Country code is +1 only — extend if we ever onboard non-US users.

export function digitsOnly(value) {
  return (value || '').replace(/\D/g, '');
}

// Formats up to 10 digits as (XXX) XXX-XXXX. With showCountryCode, prepends "+1 ".
export function formatPhone(digits, { showCountryCode = false } = {}) {
  const cleaned = digitsOnly(digits);
  if (cleaned.length === 0) return '';
  const prefix = showCountryCode ? '+1 ' : '';
  if (cleaned.length <= 3) return `${prefix}(${cleaned}`;
  if (cleaned.length <= 6) {
    return `${prefix}(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  }
  return `${prefix}(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
}

export function toE164US(digits) {
  return `+1${digitsOnly(digits)}`;
}
